<script>
import { Doughnut } from 'vue-chartjs';

export default {
  components: {},
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
    options: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  extends: Doughnut,
  mounted() {
    this.renderChart(this.data, this.options);
  },
  watch: {
    data(newVal, oldVal) {
      this.renderChart(this.data, this.options);
    },
  },
};
</script>
